import { makeHook } from "../../utils/makeSingleArgHook";
import getManualAccountsVanadium, { getManualAccountUrl, ManualAccountStatusList, ManualAccountTypeList, } from "../requests/getManualAccountDetailVanadium";
export { ManualAccountStatusList, ManualAccountTypeList };
export const getManuallyTrackedAccountDetailKeyMaker = (assetId) => [getManualAccountUrl(assetId)];
const useManuallyTrackedAccountDetail = makeHook(getManualAccountsVanadium, getManuallyTrackedAccountDetailKeyMaker);
export default useManuallyTrackedAccountDetail;
//# sourceMappingURL=useManuallyTrackedAccountDetail.js.map